import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./components/App/App";
import { CoreFacadeProvider } from "./components/App/modules/core/facades/Core.facade";
import { CoreServiceProvider } from "./components/App/modules/core/services/Core.service";
import { UIFacadeProvider } from "./components/App/modules/ui/facades/ui.facade";
import { UIServiceProvider } from "./components/App/modules/ui/services/ui.service";
import "./i18n";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  // <I18nextProvider i18n={i18n}>
  <BrowserRouter>
    {/* <React.StrictMode> */}
    <Suspense fallback="loading">
      <UIServiceProvider>
        <UIFacadeProvider>
          <CoreServiceProvider>
            <CoreFacadeProvider>
              <App />
            </CoreFacadeProvider>
          </CoreServiceProvider>
        </UIFacadeProvider>
      </UIServiceProvider>
    </Suspense>
    {/* </React.StrictMode> */}
  </BrowserRouter>,
  // </I18nextProvider>
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
